var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-1 align-self-start"},[_c('div',{staticClass:"black--text rounded-pill px-2",staticStyle:{"background-color":"#e9e9e9 !important"}},[_c('v-img',{attrs:{"src":require("@/assets/typing-loading.gif"),"contain":"","height":"32px","width":"32px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }